import PageHeader from "../components/PageHeader";
import HireAndroidDeveloperContent from "../components/Hire-Android-Content";

const HireAndroidDevelopers = () => {
    return (
        <>
            <PageHeader pagetitle="Android Developer" breadcrumbMenu="Home" breadcrumbMenuActive="Android Developer" image="/images/android-developer-banner.webp" />
            <HireAndroidDeveloperContent />
        </>
    )
}

export default HireAndroidDevelopers;